"use strict";

const MuniCatchBasinFactSheetController = function () {
  const routeName = "catch-basin-fact-sheet";

  const catchBasinFactSheetRoute = {
    as: routeName,
    handler: function ({ data, hashString }) {
      open(data.id, { highlightId: hashString });
    },
  };

  const catchBasinFactSheetHighlightRoute = {
    as: `${routeName}-highlight`,
    handler: catchBasinFactSheetRoute.handler,
  };

  var getConfig = function () {
    const MuniCatchBasinIcon = require("../muni/muniCatchBasinIcon");
    const SortUtilities = require("../general/sortUtilities");
    const alphaSorter = SortUtilities.alphaSorter;
    const numberSorter = SortUtilities.numberSorter;

    return {
      template: "factSheet/catchBasin/catchBasinFactSheet.njk",
      pointColumnName: "geom",
      iconFunction: MuniCatchBasinIcon.getMuniIconClass,
      closeUrl: UrlRoutes.getDefaultUrl(),
      goToMapFunction: () => Analytics.sendDataListEvent("address_to_map"),
      getDataFunction: getData,
      prepareDataFunction: prepareData,
      onCloseFunction: onClose,
      afterOpenFunction: afterOpen,
      readOnlyPhotos: true,
      apiAssetName: "catchBasin",
      dataSorting: {
        history: { key: "date", reversed: true },
      },
      tableTemplates: {
        history: "factSheet/catchBasin/catchBasinHistoryRows.njk",
      },
      sortersDict: {
        displayType: alphaSorter,
        inspectionTypeName: alphaSorter,
        assetId: alphaSorter,
        type: alphaSorter,
        date: alphaSorter,
        inspectionDisplayDate: alphaSorter,
        lastResultDate: alphaSorter,
        installDate: alphaSorter,
        result: alphaSorter,
        displayResult: alphaSorter,
        displayCondition: alphaSorter,
        lastResult: alphaSorter,
        treatmentCapacity: numberSorter,
        drainageArea: numberSorter,
        imperviousAreaAcres: numberSorter,
        openFindingsCount: numberSorter,
        details: alphaSorter,
      },
    };
  };

  var getData = async function (id) {
    try {
      return await ApiCalls.getCatchBasinForFactSheet(id);
    } catch (e) {
      ApiError.assertIs(e);
      if (e.status === 404) {
        return e;
      }
    }

    return await ResourceController.get("muniCatchBasin").getById(id);
  };

  var prepareData = function (data) {
    data.assetDisplayType = ToolSettings.getSetting(
      "constants",
      "assetDisplayNames",
      "catch-basin",
    );

    data.showMaintenanceZone = Tree.get("availableDataSortLayers").includes("maintenanceZones");
    data.readOnlyTopLevel = Session.isRegulator();
    FactSheetNew.addDisplayDates(data.history);
    data.siteCharacteristicsSettings = ToolSettings.getSetting("lid", "siteCharacteristics");
    data.dataView = Tree.get("dataView");
    data.phaseColor = data.phase ? BmpFcsIcon.getIconColorByPhase(data.phase, true) : "#ffffff";
    data.phaseTextColor = Misc.isDarkColor(data.phaseColor) ? "#fff" : "#000";

    data.showDeleteCatchBasinButton = data.permissions?.canBeDeleted;
    data.assetAge = AssetsPopupFunctions.getAssetAge(data.installationDate);

    Tree.set("currentBmpFcs", data);
    PopupContent.handleAssessmentHistoryReadOnly(data.history);
  };

  var open = async function (id, options = {}) {
    FactSheetNew.open(id, getConfig(), null, options);
  };

  var afterOpen = function () {
    _loadListeners();
    _handleSectionDisplay();
  };

  var _unloadListeners = function () {
    $("#fact-sheet-container")
      .off("click", ".edit-description", _clickEditDescription)
      .off("click", "#edit-general-info", _clickEditGeneralInfo)
      .off("click", "#add-file, .edit-file", _clickAddFile)
      .off("click", ".download-file", _downloadFile)
      .off("click", ".js-edit-assessment", _editAssessmentClick)
      .off("click", ".js-view-assessment", _viewAssessmentClick)
      .off("click", ".js-delete-assessment", _deleteAssessmentClick)
      .off("click", ".download-report", _downloadReportClick);
  };

  var _loadListeners = function () {
    _unloadListeners();
    $("#fact-sheet-container")
      .on("click", ".edit-description", _clickEditDescription)
      .on("click", "#edit-general-info", _clickEditGeneralInfo)
      .on("click", "#add-file, .edit-file", _clickAddFile)
      .on("click", ".download-file", _downloadFile)
      .on("click", ".js-edit-assessment", _editAssessmentClick)
      .on("click", ".js-view-assessment", _viewAssessmentClick)
      .on("click", ".js-delete-assessment", _deleteAssessmentClick)
      .on("click", ".download-report", _downloadReportClick);
  };

  var _openModalToPage = function (page) {
    BmpFcsInventoryModalController.invokeBmpInventoryModal(FactSheetNew.getId(), page);
  };

  var onClose = function () {
    _unloadListeners();
  };

  var _clickEditDescription = function () {
    _openModalToPage("bmp-fcs-information");
  };

  var _clickEditGeneralInfo = function () {
    _openModalToPage("bmp-fcs-information");
  };

  var _clickAddFile = function () {
    _openModalToPage("bmp-fcs-information");
  };

  var _downloadFile = function (e) {
    const data = $(e.currentTarget).parents(`[data-category=permit]`).data();
    if (data.idBmp && data.filename) {
      ApiCalls.downloadTrashAttachment(data.idBmp, data.filename, "fcs", "additional");
    }
  };

  var _handleSectionDisplay = function () {
    const $factSheetContainer = $("#fact-sheet-container");
    $factSheetContainer
      .find("#catch-basin-general-info-section")
      .find(".fact-group")
      .each(function () {
        if ($(this).find(".fact-item.hide").length === $(this).find(".fact-item").length) {
          $(this).addClass("hide");
        }
      });
  };

  var _editAssessmentClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();
    const readOnly = false;
    BmpFunctions.editHistory(data, readOnly);
  };

  var _viewAssessmentClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();
    const readOnly = true;
    BmpFunctions.editHistory(data, readOnly);
  };

  var _deleteAssessmentClick = function () {
    const $row = FactSheetNew.$getRow($(this));
    const data = $row.data();
    BmpFunctions.confirmDeleteHistory($row, data);
  };

  var _downloadReportClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();

    if (["routineMaintenance", "routineRepair"].includes(data.assetType)) {
      Analytics.sendPopupEvent("download_report", "muni-bmp");
      ApiCalls.downloadMuniBmpPdf(data.id);
    } else {
      throw new Error(`No download defined for ${data.assetType}`);
    }
  };

  return {
    routeName,
    catchBasinFactSheetRoute,
    catchBasinFactSheetHighlightRoute,
    open,
    getConfig,
  };
};

module.exports = MuniCatchBasinFactSheetController();

const ApiCalls = require("../apiCalls");
const ApiError = require("../errors/apiError");
const ResourceController = require("../offline/resourceController");
const FactSheetNew = require("../general/factSheetNew");
const Analytics = require("../general/analytics");
const Session = require("../login/session");
const ToolSettings = require("../settings/toolSettings");
const Tree = require("../tree");
const BmpFcsInventoryModalController = require("../bmpfcs/bmpFcsInventoryModalController");
const Misc = require("../misc");
const BmpFcsIcon = require("../bmpfcs/bmpFcsIcon");
const AssetsPopupFunctions = require("../assetManagement/assetsPopupFunctions");
const BmpFunctions = require("../modals/bmpFunctions");
const PopupContent = require("../mapFunctions/popupContent");
const UrlRoutes = require("../routes/urlRoutes");
